import * as Yup from 'yup';

const schema = Yup.object().shape({
  isTermsAccepted: Yup.bool()
    .required('Você deve aceitar os termos de uso e políticas de privacidade')
    .oneOf([true], 'Você deve aceitar os termos de uso e políticas de privacidade'),
});

export default schema;
